import { useFetch } from './fetch';
import { FeatureFlag } from './types/featureFlag';

export const useFeatureFlags = () => {
  const { isLoading, serverError, apiData } = useFetch(
    'GET',
    `${process.env.REACT_APP_BACKEND_API_URL}/rcm/featureFlags`,
    {},
    false,
  );

  const isFeatureActive = (featureFlag: FeatureFlags) => {
    const featureFlags = apiData as unknown as FeatureFlag[];

    return (
      !isLoading &&
      featureFlags.some((ff) => ff.name === featureFlag && ff.value === true)
    );
  };

  return {
    isLoading,
    featureFlags: apiData as unknown as FeatureFlag[],
    serverError,
    isFeatureActive,
  };
};

export enum FeatureFlags {
  FITCF0356 = 'FITCF0356',
}
